const MAX_INITIALS = 2;

const toInitials = (name: string) => name
  .split(/[\s.]+/)
  .filter(Boolean)
  .slice(0, MAX_INITIALS)
  .map(word => word[0].toUpperCase())
  .join('');

export {
  toInitials,
};
